module.exports = __webpack_public_path__ + "img/dark_arr.f7683187.svg";